import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { CheckboxGroup } from 'components/common/CheckboxGroup/CheckboxGroup';
import './AssessmentQuestionFilter.scss';

export const AssessmentQuestionFilter = props => {
  const { checkedStatus, onChangeStatus, checkedRequired, onChangeRequired, checkedCommentsAvailable, onChangeComments, hasComments } = props;
  const { t } = useTranslation();

  const statusOptions = [
    { testId: 'assessment-filter-complete', value: 'true', label: t('assessment.filters.statusFilter.complete') },
    { testId: 'assessment-filter-incomplete', value: 'false', label: t('assessment.filters.statusFilter.incomplete') }
  ];

  const requiredOptions = [{ testId: 'assessment-filter-required', value: 'true', label: t('assessment.filters.requiredFilter.required') }];

  const commentOptions = [
    { testId: 'assessment-filter-commentsAvailable', value: 'true', label: t('assessment.filters.commentsFilter.commentsAvailable') }
  ];

  return (
    <div className="outer-filter-section-padding">
      <div className="status-filter-section">
        <p id="status_title" className="status-filter-title">
          {t('assessment.filters.statusFilter.title')}
        </p>
      </div>
      <CheckboxGroup id="requiredOptionCheckbox" options={requiredOptions} checked={checkedRequired || []} onChange={onChangeRequired} />
      <div>
        <CheckboxGroup id="statusOptionCheckbox" options={statusOptions} checked={checkedStatus || []} onChange={onChangeStatus} />
      </div>
      {hasComments && (
        <CheckboxGroup id="commentsOptionCheckbox" options={commentOptions} checked={checkedCommentsAvailable || []} onChange={onChangeComments} />
      )}
    </div>
  );
};

AssessmentQuestionFilter.propTypes = {
  onChangeRequired: PropTypes.func.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  onChangeComments: PropTypes.func.isRequired,
  checkedRequired: PropTypes.oneOfType([PropTypes.array]),
  checkedStatus: PropTypes.oneOfType([PropTypes.array]),
  checkedCommentsAvailable: PropTypes.oneOfType([PropTypes.array]),
  hasComments: PropTypes.bool.isRequired
};

AssessmentQuestionFilter.defaultProps = {
  checkedStatus: [],
  checkedRequired: [],
  checkedCommentsAvailable: []
};

export default AssessmentQuestionFilter;
